import type { UseInfiniteQueryResult } from '@tanstack/react-query';
import React from 'react';

export const useInfiniteQueryFetchAllPages = (result: UseInfiniteQueryResult): void => {
  React.useEffect(() => {
    if (result.isFetchingNextPage || !result.hasNextPage) return;
    result.fetchNextPage();
  }, [result.isFetchingNextPage, result.hasNextPage]);
};
